import script from "./growth-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./growth-settings.vue?vue&type=script&setup=true&lang=js"

import "./growth-settings.vue?vue&type=style&index=0&id=60f25e50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f25e50"]])

export default __exports__